/* Generated apis ---------------------- */
import { to } from "react-lib/utils";
import BaseService from "react-lib/apis/services/BaseService";
import config from "../../config/config";
const HOST = `${config.API_HOST}`;
/* ['generics.RetrieveUpdateDestroyAPIView', 'SetLanguageContextMixin'] */
/* params:  */
/* data: 'token', 'canceled_reason' */
const TreatmentPlanDetailView: {
  retrieve: ({ exam_id, pk, params, apiToken, extra }: { exam_id: any; pk: any; params?: any; apiToken?: any; extra?: any }) => any;
  delete: ({ exam_id, pk, params, apiToken, extra, data }: { exam_id: any; pk: any; params?: any; apiToken?: any; extra?: any, data: any }) => any;
  update: ({ exam_id, pk, params, data, apiToken, extra }: { exam_id: any; pk: any; params?: any; data?: any; apiToken?: any; extra?: any }) => any;
  patch: ({ exam_id, pk, params, data, apiToken, extra }: { exam_id: any; pk: any; params?: any; data?: any; apiToken?: any; extra?: any }) => any;
} = {
  retrieve: async ({ exam_id, pk, params, apiToken, extra }) => {
    const base = new BaseService();
    if (apiToken) base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division) base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device) base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(
      base.client
        .get(`${HOST}/apis/DEN/examination/${exam_id}/treatment-plan/${pk}/`, { params: params ? { ...params } : {}, ...extra })
        .then(base.handleResponse)
        .catch(base.throwErrorMessage)
    );
    return [result[1], result[0], result[2]];
  },

  delete: async ({ exam_id, pk, params, apiToken, extra, data }) => {
    const base = new BaseService();
    if (apiToken) base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division) base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device) base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(
      base.client
        .delete(`${HOST}/apis/DEN/examination/${exam_id}/treatment-plan/${pk}/`, { params: params ? { ...params } : {}, ...extra, data })
        .then(base.handleResponse)
        .catch(base.throwErrorMessage)
    );
    return [result[1], result[0], result[2]];
  },

  update: async ({ exam_id, pk, params, data, apiToken, extra }) => {
    const base = new BaseService();
    if (apiToken) base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division) base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device) base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(
      base.client
        .put(`${HOST}/apis/DEN/examination/${exam_id}/treatment-plan/${pk}/`, data, { params: params ? { ...params } : {}, ...extra })
        .then(base.handleResponse)
        .catch(base.throwErrorMessage)
    );
    return [result[1], result[0], result[2]];
  },

  patch: async ({ exam_id, pk, params, data, apiToken, extra }) => {
    const base = new BaseService();
    if (apiToken) base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division) base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device) base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(
      base.client
        .patch(`${HOST}/apis/DEN/examination/${exam_id}/treatment-plan/${pk}/`, data, { params: params ? { ...params } : {}, ...extra })
        .then(base.handleResponse)
        .catch(base.throwErrorMessage)
    );
    return [result[1], result[0], result[2]];
  },
};

export default TreatmentPlanDetailView;
